import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Ec_horse } from '../models/ec/ec_horse';

@Injectable({
  providedIn: 'root'
})
export class EcHorseSearchService {

  constructor(private http: HttpClient) { }

  getById(search_id_term: string): Promise<Ec_horse> {
    return new Promise((resolve, reject) => {
      return this.http.get('https://licence.equestrian.ca/resultsws/wcf/ResultsWCF.svc/GetECHorseByPPN?ppn=' + search_id_term + '&compId=1111&password=barn').subscribe((response: any) => {
        resolve(response);
      },
        error_response => {
          if (error_response instanceof HttpErrorResponse) {
            reject(error_response.error);
          }
          reject(error_response);
        });
    });
  }

  getByName(search_name_term: string): Promise<Ec_horse[]> {
    return new Promise((resolve, reject) => {
      return this.http.get('https://licence.equestrian.ca/resultsws/wcf/ResultsWCF.svc/GetECHorses_ByHorseName?name=' + encodeURIComponent(search_name_term) + '&compId=1111&password=barn').subscribe((response: any) => {
        resolve(response);
      },
        error_response => {
          if (error_response instanceof HttpErrorResponse) {
            reject(error_response.error);
          }
          reject(error_response);
        });
    });
  }

}
